import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import { useStoreContext } from "../../contexts/store.context";
import type { OrderingOptionType } from "../../types";
import useClickOutside from "~/hooks/useClickOutside";

export const OrderBy = () => {
    const { orderBy, setOrderBy, availableOrdering } = useStoreContext();
    const [currentOrdering, setCurrentOrdering] = useState<OrderingOptionType>(undefined);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropDownRef = useClickOutside(() => {
        setShowDropdown(false);
    }) as React.RefObject<HTMLDivElement>;

    useEffect(() => {
        setCurrentOrdering(orderBy ?? availableOrdering?.[0]);
    }, [orderBy, availableOrdering]);


    const selectOption = (option) => {
        if (option !== currentOrdering) {
            setOrderBy(option);
        }
        setShowDropdown(false);
    }

    return <div className="relative" ref={dropDownRef}>
        <button className="text-left flex flex-row gap-2 items-center border border-white/30 py-2 px-4 rounded" onClick={() => setShowDropdown(true)}>
            <div className="flex-1">{currentOrdering?.label}</div>
            <FontAwesomeIcon icon={faChevronDown} />
        </button>
        {showDropdown && <div className="absolute z-10 mt-2 flex flex-col gap-2 bg-black p-2 border border-white/30 rounded w-max">
            {availableOrdering?.map(option => <button
                key={option.value}
                onClick={() => selectOption(option)}
                className={`text-left flex flex-row justify-start gap-4 rounded p-2 hover:bg-white/10`}>
                <div className="flex-1">{option.label}</div>
                <FontAwesomeIcon icon={faCheck} className={twMerge(option === currentOrdering ? 'visible' : 'invisible')} />
            </button>)}
        </div>}
    </div>
}